export enum MESSAGE_SUCCESS {
  M01 = 'success',
}
